import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const MySurveysIndexPage = () => {
  return (
    <ResponsivePage.Body showHeader={false} variant="fullscreen">
      <Outlet />
    </ResponsivePage.Body>
  )
}
export default MySurveysIndexPage
